import { fetchFormsList } from "@/api/forms";
import type { FormsListParams, FormsListResponse } from "@/types/formList";

function clampPageSize(count: number | undefined): number {
  const raw = count ?? 15;
  if (!Number.isFinite(raw)) return 15;
  return Math.min(100, Math.max(1, Math.trunc(raw)));
}

export async function loadFormsPage(
  params: FormsListParams = {},
): Promise<FormsListResponse> {
  const view = params.view;
  return fetchFormsList({
    page: params.page ?? 1,
    count: clampPageSize(params.count),
    search: params.search?.trim() || undefined,
    isClosed: params.isClosed,
    sort: params.sort ?? "-createdAt",
    source: params.source,
    organisationId: view ? undefined : params.organisationId,
    view,
  });
}
